import React, { Fragment } from 'react';

import AnalysisDocumentsListItem from './AnalysisDocumentsListItem.component.jsx';
import PropTypes from 'prop-types';

const AnalysisDocumentsList = ({ documents = [], onDocumentDelete, isAdminLocked }) => {
    return (
        <Fragment>
            {documents.length
                ? documents.map(document => (
                      <AnalysisDocumentsListItem
                          key={document.url}
                          onDocumentDelete={() => onDocumentDelete(document.url)}
                          isAdminLocked={isAdminLocked}
                          {...document}
                      />
                  ))
                : null}
        </Fragment>
    );
};

AnalysisDocumentsList.propTypes = {
    onDocumentDelete: PropTypes.func.isRequired,
    isAdminLocked: PropTypes.bool.isRequired,
    documents: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ),
};

export default AnalysisDocumentsList;
